import React, { Component } from 'react'
import { Button, Card, Dialog, Classes, Slider } from "@blueprintjs/core"
import Dropzone from 'react-dropzone'
import VideoThumbnail from 'react-video-thumbnail'
import { Dropdown as DropdownSem } from 'semantic-ui-react'
import { connect } from 'react-redux'
import _ from 'lodash'
import is from 'is_js'
import moment from 'moment'
import Loading from '../../../Shared/LoadingCharts'
import Truncate from '../../../Shared/Truncate'
import DropDown from '../../../Shared/DropDown'
import Alert from '../../../Shared/Alert'
import SocialIcons from '../../../Shared/SocialIcons'
import Modal from '../../../Shared/Modal'
import axios from '../../../../services/axios'
import storage from '../../../../services/storage'
import numeral from 'numeral'
import Swiper from 'react-id-swiper'
import Preview from '../Preview'

import placeholder from '../../../../assets/img/placeholder.png'

import 'react-big-calendar/lib/css/react-big-calendar.css'
import './styles.css'

const zone = moment().format('Z')
const defaultData = {
    id: null,
    event: {},
    category: 'No category',
    client_state: 'NOT CONTENT',
    startsAt: new Date(),
    comments: '',
    copy: '',
    update: false,
    provider: '',
    state: 'PENDING',
    images: [],
    files: [],
    filesAccept: 'image/*, video/*, image/avi, image/bmp, image/cgm, image/cis-cod, image/dicom-rle, image/emf, image/example, image/fits, image/flif, image/g3fax, image/gif, image/ief, image/jls, image/jp2, image/jpeg, image/jpeg2000, image/jpeg2000-image, image/jpg, image/jpm, image/jpx, image/jxr, image/ktx, image/mov, image/naplps, image/nitf, image/ntf, image/openraster, image/pict, image/png, image/prs.btif, image/prs.pti, image/pwg-raster, image/svg+xml, image/svg-xml, image/t38, image/tif, image/tiff, image/tiff-fx, image/vnd-svf, image/vnd-wap-wbmp, image/vnd.adobe.photoshop, image/vnd.adobe.premiere, image/vnd.cns.inf2, image/vnd.djvu, image/vnd.dwf, image/vnd.dwg, image/vnd.dxb, image/vnd.dxf, image/vnd.fastbidsheet, image/vnd.fpx, image/vnd.fst, image/vnd.fujixerox.edmics-mmr, image/vnd.fujixerox.edmics-rlc, image/vnd.globalgraphics.pgb, image/vnd.microsoft.icon, image/vnd.mix, image/vnd.mozilla.apng, image/vnd.ms-modi, image/vnd.ms-photo, image/vnd.net-fpx, image/vnd.radiance, image/vnd.rn-realflash, image/vnd.sealed.png, image/vnd.sealedmedia.softseal.gif, image/vnd.sealedmedia.softseal.jpg, image/vnd.svf, image/vnd.tencent.tap, image/vnd.valve.source.texture, image/vnd.wap.wbmp, image/vnd.xiff, image/vnd.zbrush.pcx, image/vpb, image/webp, image/wmf, image/x-3ds, image/x-bmp, image/x-bpg, image/x-canon-crw, image/x-cmu-raster, image/x-cmx, image/x-dcx, image/x-djvu, image/x-dpx, image/x-dwf, image/x-dwg, image/x-exr, image/x-freehand, image/x-icon, image/x-jng, image/x-jp2-codestream, image/x-jp2-container, image/x-jpeg2000-image, image/x-mrsid, image/x-mrsid-image, image/x-ms-bmp, image/x-niff, image/x-pcx, image/x-pict, image/x-portable-anymap, image/x-portable-arbitrarymap, image/x-portable-bitmap, image/x-portable-graymap, image/x-portable-pixmap, image/x-psd, image/x-quicktime, image/x-raw-adobe, image/x-raw-canon, image/x-raw-casio, image/x-raw-epson, image/x-raw-fuji, image/x-raw-hasselblad, image/x-raw-imacon, image/x-raw-kodak, image/x-raw-leaf, image/x-raw-logitech, image/x-raw-mamiya, image/x-raw-minolta, image/x-raw-nikon, image/x-raw-olympus, image/x-raw-panasonic, image/x-raw-pentax, image/x-raw-phaseone, image/x-raw-rawzor, image/x-raw-red, image/x-raw-sigma, image/x-raw-sony, image/x-rgb, image/x-sgi-bw, image/x-sld, image/x-sun-raster, image/x-tif, image/x-tiff, image/x-win-bitmap, image/x-wmf, image/x-xbitmap, image/x-xcf, image/x-xpixmap, image/x-xwindowdump, image/xcf, video/3gpp, video/3gpp-tt, video/3gpp2, video/avi, video/bmpeg, video/bt656, video/celb, video/daala, video/dv, video/example, video/h261, video/h263, video/h263-1998, video/h263-2000, video/h264, video/jpeg, video/jpeg2000, video/jpm, video/mj2, video/mp1s, video/mp1s, video/mp2p, video/mp2p, video/mp2t, video/mp4, video/mp4v-es, video/mpeg, video/mpeg2, video/mpeg4-generic, video/mpg, video/mpv, video/msvideo, video/nv, video/ogg, video/parityfec, video/pointer, video/quicktime, video/raw, video/rtp-enc-aescm128, video/rtx, video/smpte292m, video/theora, video/ulpfec, video/vc1, video/vnd-vivo, video/vnd.avi, video/vnd.cctv, video/vnd.dlna.mpeg-tts, video/vnd.fvt, video/vnd.hns.video, video/vnd.iptvforum.1dparityfec-1010, video/vnd.iptvforum.1dparityfec-2005, video/vnd.iptvforum.2dparityfec-1010, video/vnd.iptvforum.2dparityfec-2005, video/vnd.iptvforum.ttsavc, video/vnd.iptvforum.ttsmpeg2, video/vnd.motorola.video, video/vnd.motorola.videop, video/vnd.mpegurl, video/vnd.ms-playready.media.pyv, video/vnd.nokia.interleaved-multimedia, video/vnd.nokia.videovoip, video/vnd.objectvideo, video/vnd.radgamettools.bink, video/vnd.radgamettools.smacker, video/vnd.rn-realvideo, video/vnd.sealed.mpeg1, video/vnd.sealed.mpeg4, video/vnd.sealed.swf, video/vnd.sealedmedia.softseal.mov, video/vnd.vivo, video/webm, video/x-daala, video/x-dirac, video/x-dv, video/x-f4v, video/x-flc, video/x-fli, video/x-flv, video/x-jng, video/x-m4v, video/x-matroska, video/x-matroska, video/x-mng, video/x-mpeg, video/x-mpeg2a, video/x-mpg, video/x-ms-asf, video/x-ms-asf-plugin, video/x-ms-wm, video/x-ms-wma, video/x-ms-wmv, video/x-ms-wmx, video/x-ms-wvx, video/x-msvideo, video/x-ogg-rgb, video/x-ogg-uvs, video/x-ogg-yuv, video/x-oggrgb, video/x-ogguvs, video/x-oggyuv, video/x-ogm, video/x-quicktime, video/x-sgi-movie, video/x-theora',
    posts: [],
    visible: false,
    activeNetworks: [],
    labels: [],
    loading: false,
    edit: false,
    vision: false
  }

class NewEvent extends Component {
  constructor(props){
    super(props)

    this.state = {
      networks: [],
      ...defaultData
    }

    this.hide = this.hide.bind(this)
    this.show = this.show.bind(this)

    this.getLabels = this.getLabels.bind(this)
    this.updateFiles = this.updateFiles.bind(this)
    this.onGeneratePosts = this.onGeneratePosts.bind(this)
    this.onCreate = this.onCreate.bind(this)
    this.onAssetDelete = this.onAssetDelete.bind(this)
    this.onDelete = this.onDelete.bind(this)
    this.onSelectDay = this.onSelectDay.bind(this)
    this.onFileDelete = this.onFileDelete.bind(this)
    this.preview = this.preview.bind(this)
    this.onDropFiles = this.onDropFiles.bind(this)
    this.onChangeCopy = this.onChangeCopy.bind(this)
    this.onKeyUpMessage = _.debounce(this.onKeyUpMessage.bind(this), 300)
    this.placeholderType = this.placeholderType.bind(this)
    this.getPosts = this.getPosts.bind(this)
    this.onChangeState = this.onChangeState.bind(this)
    this.renderBestPostsImages = this.renderBestPostsImages.bind(this)
    this.onChangeNetworks = this.onChangeNetworks.bind(this)
    this.validate = this.validate.bind(this)
  }

  hide(){
    this.setState({
      ...defaultData
    })
  }

  show(data = {}){
    this.setState({
      ...defaultData,
      visible: true,
      update: !!data.id,
      event: {
        ...data,
        categoria_id: !!data.categoria_id ? data.categoria_id.id : null,
        startsAt: !!data.startsAt ? new Date(data.startsAt) : null
      },
      ...data,
      activeNetworks: !!data.provider ? [data.provider] : [],
      startsAt: !!data.startsAt ? new Date(data.startsAt) : new Date(),
      category: data.categoria_id && data.categoria_id.name ? data.categoria_id.name : 'No category',
      edit: data.client_state != 'APPROVED BY CLIENT'
    }, ()=>{
      this.getLabels()
      setTimeout(()=>{
        window.jQuery(this.datetimepicker).datepicker({
          minDate: new Date(),
          onSelect: this.onSelectDay,
          toggleSelected: false,
          startDate: this.state.startsAt
        })
        if(moment().isBefore(this.state.startsAt)){
          const datepicker = window.jQuery(this.datetimepicker).datepicker().data('datepicker')
          datepicker.selectDate(this.state.startsAt)
        }

        window.jQuery(this.copy).emojioneArea({
          pickerPosition: "right",
          tonesStyle: "bullet",
          container: '#emojiArea',
          events: {
            keyup: _.debounce(this.onChangeCopy, 300),
            paste: _.debounce(this.onChangeCopy, 300),
            emojibtn_click: _.debounce(this.onChangeCopy, 300),
            focus: _.debounce(this.onChangeCopy, 300),
            ready: ()=>{
              setTimeout(()=>{
                const emojiArea = window.jQuery(this.copy).data("emojioneArea")
                this.state.client_state == 'APPROVED BY CLIENT' && emojiArea.disable()
              }, 100)
            }
          }
        })
      }, 100)
    })
  }

  onChangeNetworks(network, update=false){
    const {activeNetworks, copy} = this.state

    if(copy && copy.length > 280 && network == 'twitter' && !activeNetworks.includes('twitter')){
      this.alert.show({
        body: 'Your twitter post has more than the 280 characters permitted, please modify it'
      })
    }else{
      const providers = ['facebook', 'instagram', 'twitter', 'linkedin']
      let networks = update ? [network] : _.xor(activeNetworks, [network])

      networks = _.reduce(providers, (data, provider, index)=>{
        if(networks.includes(provider)){
          data = _.concat(data, provider)
        }
        return data
      }, [])

      if(networks.includes(network)){
        const index = providers.indexOf(network)
        this.providerInfo.slideTo(index)
      }else if(!update && networks.length > 0){
        const index = providers.indexOf(networks[0])
        this.providerInfo.slideTo(index)
      }

      this.setState({
        activeNetworks: networks
      })
    }
  }

  onChangeState(state){
    this.setState({
      client_state: state
    })
  }

  updateFiles(posts){
    const files = _.map(this.state.files, (file)=>{
      const formData = new FormData()
      formData.append('file', file.file)
      formData.append('ids', posts)
      formData.append('type', file.file.type.split('/')[0])

      return storage.get('page')
      .then((page)=>{
        return axios.post(`upload/assets/${page}`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        })
      })
    })
    return Promise.all(files)
  }

  onKeyUpMessage(event){
    this.setState({
      comments: event.target.value
    })
  }

  onChangeCopy(){
    const text = window.jQuery(this.copy).data("emojioneArea").getText()
    this.setState({
      copy: text
    })
  }

  onDelete(){
    if(this.state.update && this.state.edit){
      storage.get('page')
      .then((page)=>{
        return axios.delete(`calendar/${page}/posts/${this.state.id}`)
      }).then((response)=>{
        const { update } = this.state
        this.hide()
        update && this.props.onDelete && this.props.onDelete()
      }).catch((error)=>{
        console.log(error)
      })
    }else{
      this.hide()
      this.props.onCancel && this.props.onCancel()
    }
  }

  onCreate(){
    const category = _.find(this.props.categories, (category)=>{
      return category.name.toUpperCase() == this.state.category.toUpperCase()
    })

    const providers = _.map(this.accounts.querySelectorAll(':checked'), (input, index)=>{
      return input.value
    })

    const post = {
      categoria_id: category.id,
      startsAt: this.state.startsAt,
      copy: this.state.copy,
      comments: this.state.comments,
      client_state: this.state.client_state
    }

    const changes = _.pickBy(this.state.event, (value, key)=>{
      return _.has(post, key) &&  !_.isEqual(post[key], value)
    }) 
    

    if(
      this.state.update && 
      _.size(changes) == 0 && 
      _.isEqual(this.state.event.provider, providers[0]) &&
      _.isEqual(this.state.images, this.state.event.images) &&
      this.state.files.length == 0
    ){
      this.hide()
    }else if(post.copy && post.copy.length > 280 && providers.includes('twitter')){
      this.alert.show({
        body: 'Your twitter post has more than the 280 characters permitted, please modify it'
      })
    }else{
      this.setState({
        loading: true
      }, ()=>{
        setTimeout(()=>{
          post.startsAt = moment(post.startsAt).utcOffset(zone)
          this.onGeneratePosts(category, providers, changes, post)
        },500)
      })
    }
  }

  onGeneratePosts(category, providers, changes, post){
    if(this.state.update){
      const provider = providers[0]
      storage.get('page')
      .then((page)=>{
        return axios.put(`calendar/${page}/posts/${this.state.id}`, {
          ...post, 
          provider
        })
      }).then((post)=>{
        return this.updateFiles([this.state.id])
      }).then((response)=>{
        const { update } = this.state
        this.hide()
        update && this.props.onUpdate && this.props.onUpdate()
      }).catch((error)=>{
        console.log(error)
      })
    }else{
      const requests = providers.map((provider)=>{
        return storage.get('page')
        .then((page)=>{
          return axios.post(`calendar/${page}/posts`, {
            ...post, 
            title: '',
            provider
          })
        })
      })

      Promise.all(requests)
      .then((posts)=>{
        posts = _.map(posts, 'data.data.post.id') 
        return this.updateFiles(posts)
      }).then((response)=>{
        this.hide()
        this.props.onCreate && this.props.onCreate()
      }).catch((error)=>{
        console.log(error)
      })
    }
  }

  validate(){
    const { client_state, startsAt, copy } = this.state
    const providers = _.map(this.accounts.querySelectorAll(':checked'), (input, index)=>{
      return input.value
    })

    return new Promise((resolve, reject) => {
      if(client_state == 'APPROVED BY CLIENT'){
        const today = moment().add(10, 'mm')
        moment(startsAt).isBefore(today)

        if(moment(startsAt).isBefore(today)){
          reject('You have to scheadule your post 10 min prior to the desire time')
        }else if(is.empty((copy || '').replace(/\s+/g, ''))){
          reject('You have to add a copy to your post')
        }
      }else if(providers.length == 0){
        reject('Select a account')
      }

      resolve('fine')
    })
  }

  onSelectDay(formattedDate, date, inst){
    this.setState({
      startsAt: date
    })
  }

  onAssetDelete(id){
    storage.get('page')
    .then((page)=>{
      return axios.delete(`/calendar/${page}/posts/${this.state.id}/${id}`)
    }).then((post)=>{
      const images = _.filter(this.state.images, (image)=>{
        return image.id != id
      })
      this.setState({
        images: images
      })
    }).catch((error)=>{
      console.log(error)
    })
  }

  onFileDelete(index){
    const { files } = this.state
    let newfiles = _.filter(files, (file, _index)=>(index !== _index))

    this.setState({
      files: newfiles
    })
  }

  onDropFiles(newfiles) {
    const { files, images } = this.state

    newfiles =  newfiles.map((file) => {
      return {
        file: file
      }
    })

    newfiles = _.concat(files, newfiles)

    const group = _.groupBy(_.concat(newfiles, images), (file)=>{
      return !!file.file ? file.file.type.split('/')[0].toLowerCase() : file.type.toLowerCase()
    })

    switch(true) {
      case !group.image && !!group.video && group.video.length > 1:
        this.alert.show({body: 'You can upload only one video per post'})
        break
      case !!group.image && !!group.video:
        this.alert.show({body: 'You can only schedule videos or images, please select only one format'})
        break
      default:
        newfiles = newfiles.map((file) => {
          !file.preview && (file.preview = URL.createObjectURL(file.file))
          return file
        })

        this.setState({
          files: newfiles
        })
        break
    }
  }

  preview(preview, id, file, poster){
    const { client_state } = this.state

    return (
      <div className="filesThumbContainer">
        {!this.state.update || (this.state.update && this.state.edit) && (
          <div className="filesThumbDelete"
            onClick={(event)=>{
              event.stopPropagation()
              event.nativeEvent.stopImmediatePropagation()
              !!file ? this.onFileDelete(id) : this.onAssetDelete(id)
            }}
          >
            <i className="fas fa-times"></i>
          </div>
        )}
        <Preview 
          file={preview}
          poster={poster}
          type={!!file ? file.type : undefined} 
        />
      </div>
    )
  }


  placeholderType(){
    let type = null
    const { files, images } = this.state
    const group = _.groupBy(_.concat(files, images), (file)=>{
      return !!file.file ? file.file.type.split('/')[0].toLowerCase() : file.type.toLowerCase()
    })

    switch(true) {
      case !!group.video:
        type = (
          <div>
            <i className="fas fa-video"></i>
          </div>
        )
        break
      case !!group.image:
        type = (
          <div>
            <i className="far fa-image"></i>
          </div>
        )
        break
      default:
        type = (
          <div>
            <i className="fas fa-font"></i>
          </div>
        )
        break
    }

    return (
      <div>{type}</div>
    )
  }

  renderBestPostsImages() {
    const posts = this.getPosts()
    
    return (
      <div className="bestPostContainer">
        <div className="bestPostItems" >
          {posts.slice(0, 5).map((post)=>{
            return (
              <div
                key={post.id}
                className="bestPostItem" >
                <div
                  className="bestPostImage"
                  style={{
                    backgroundImage: !!post.picture && `url(${post.picture})`,
                    backgroundSize:  !post.picture && '20px 20px',
                    backgroundColor:  !post.picture && 'transparent' 
                  }} 
                />
                <div
                  className="bestPostImageHover" >
                  <p>ENG Score</p>
                  <p>{numeral(post.es_calculated).format('0,0[.]00')}%</p>
                </div>
              </div>
            )
          })}
          {_.range(0, 5-posts.length, 1).map((post)=>{
            return (
              <div
                className="bestPostItem" >
                <div
                  className="bestPostImage"
                  style={{
                    backgroundImage: `url(${placeholder})`
                  }} 
                />
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  getLabels(){
    const category = _.find(this.props.categories, (category)=>{
      return category.name.toUpperCase() == this.state.category.toUpperCase()
    })

    storage.get('page')
    .then((page)=>{
      //`social/vision/${page}/labels?category_id=1&top=30&provider=instagram`
      return axios.get(`social/vision/${page}/labels?category_id=${category.id}&top=20`)
    }).then((response)=>{
      this.setState({
        labels: response.data.data.slice(0, 20)
      })
    }).catch((error)=>{
      console.warn(error)
    })
  }

  getPosts(){
    const category = _.find(this.props.categories, (category)=>{
      return category.name.toUpperCase() == this.state.category.toUpperCase()
    })

    const posts = _.filter(this.props.posts, (post)=>{
      const {activeNetworks} = this.state
      const include = activeNetworks.length > 0 ?  activeNetworks.includes(post.provider) : true

      return post.categoria_id == category.id && include
    })

    return posts
  }

  componentWillUnmount(){
    const { files } = this.state
    for (let i = files.length; i > 0; i--) {
      const file = files[0]
      URL.revokeObjectURL(file.preview)
    }
  }

  componentDidMount(){
    storage.get('page')
    .then((page)=>{
      return axios.get(`brandSettings/${page}`)
    }).then((response)=>{
      const providers = ['facebook', 'instagram', 'twitter', 'linkedin']
      const networks = _.reduce(providers, (data, provider, index)=>{
        const networks = response.data.data.networks
        const network = _.find(networks, {
          provider: provider
        })

        if(!!network){
          data = _.concat(data, network)
        }
        return data
      }, [])

      this.setState({
        networks: networks
      })
    }).catch((error)=>{
      console.warn(error)
    })
  }

  render () {
    const { permissions } = this.props

    return(
      <Modal
        isOpen={this.state.visible}
        onClose={()=>{
          this.state.update && this.state.client_state != 'APPROVED BY CLIENT' && this.onCreate()
        }}
        customMaskStyles={{
          cursor: this.state.client_state != 'APPROVED BY CLIENT' && this.state.update ? 'pointer' : 'default'
        }}  
        className={`bp3-dark calendarPosts ${!this.state.vision ? 'calendarPostsVision' : ''}`}>
          <Alert 
            confirm
            ref={(alert)=>(alert && (this.alert = alert))}
          />
          {this.state.visible && (
            <div className={Classes.DIALOG_BODY}>
              <div className="newEventContent">
                <div className="grid newEventGrid">
                  <div className="col-7">
                    <Card className="bp3-dark" style={{ paddingBottom: '0' }}>
                      <div className="calendarPostsConfig">
                        <div className="grid calendarPostsConfigContainer">
                          <div className="col-4">
                            <div className="calendarPostsConfigDate">
                              <input
                                id='datetimepicker'
                                data-language='en' 
                                data-timepicker='true'
                                disabled={this.state.update && !this.state.edit}
                                ref={(datetimepicker)=>(this.datetimepicker = datetimepicker)} 
                                type="text" />
                                <label
                                  disabled={this.state.client_state == 'APPROVED BY CLIENT'}
                                  htmlFor='datetimepicker'
                                >
                                  {moment(this.state.startsAt).format('DD/MM/YYYY hh:mm a')}
                                </label>
                            </div>
                          </div>
                          <div className="col-1" style={{ paddingRight: '0' }}>
                            <span className="searchCalendarIcon button-primary"><i className="far fa-calendar-alt"></i></span>
                          </div>
                          <div className="col-7" style={{ paddingLeft:'0' }}>
                            <div className="postExtrasCategory">
                              <DropDown
                                bsStyle='default'
                                disabled={this.state.update && !this.state.edit}
                                title={this.state.category}
                              >
                              {this.props.categories.map((category, index)=>{
                                return (
                                  <DropdownSem.Item 
                                    onClick={()=>{
                                      this.setState({
                                        category: category.name
                                      }, this.getLabels)
                                    }} 
                                    active={this.state.category === category.name}>
                                    {category.name}
                                  </DropdownSem.Item>
                                )
                              })}
                              </DropDown>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="calendarPostsImages">
                        <div className="providerInfoSlider">
                          <Swiper 
                            effect='fade'
                            rebuildOnUpdate={false}
                            direction='horizontal'
                            autoHeight
                            spaceBetween={0}
                            initialSlide={['facebook', 'instagram', 'twitter', 'linkedin'].indexOf(this.state.provider)}
                            pagination={{
                              el: '.swiper-pagination',
                              type: 'bullets',
                              clickable: true
                            }}
                            ref={(swiper)=>(swiper && (this.providerInfo = swiper.swiper))}
                          >
                            <div>
                              <div className="providerInfo">
                                <div className="providerInfoLogo">
                                  <i className="fab fa-facebook-f"></i>
                                </div>
                                <div className="providerInfoTxt">
                                    <p>Image 1,200 x 1,200</p>
                                    <p>Video 1,200 x 675 4MB</p>
                                </div>
                              </div>
                            </div>
                            <div>
                              <div className="providerInfo">
                                <div className="providerInfoLogo">
                                  <i className="fab fa-instagram"></i>
                                </div>
                                <div className="providerInfoTxt">
                                    <p>Image 1,080 x 1,080</p>
                                    <p>Video 1,080 x 1,080 4MB</p>
                                </div>
                              </div>
                            </div>
                            <div>
                              <div className="providerInfo">
                                <div className="providerInfoLogo">
                                  <i className="fab fa-twitter"></i>
                                </div>
                                <div className="providerInfoTxt">
                                    <p>Image 1,024 x 512</p>
                                    <p>Video 1,024 x 512 3MB</p>
                                </div>
                              </div>
                            </div>
                            <div>
                              <div className="providerInfo">
                                <div className="providerInfoLogo">
                                  <i className="fab fa-linkedin-in"></i>
                                </div>
                                <div className="providerInfoTxt">
                                    <p>Image 1,200 x 1,200</p>
                                    <p>Video 1,200 x 675 4MB</p>
                                </div>
                              </div>
                            </div>
                          </Swiper>
                        </div>
                        <div className="fileInput">
                          <Dropzone
                            onDrop={this.onDropFiles}
                            accept={this.state.filesAccept}
                            disabled={this.state.update && !this.state.edit}
                            className={`calendarDropZone ${this.state.update && !this.state.edit && 'disabled'}`}
                          >
                            <div
                              className="calendarDropZoneContainer"
                            >
                              <div className="calendarFilesThumbs">
                                {this.state.images.map((asset, index) => {
                                  return this.preview(asset.url, asset.id, undefined, asset.thumbnail)
                                })}
                                {this.state.files.map(({preview, file}, index) => {
                                  return this.preview(preview, index, file)
                                })}
                              </div>
                              {(this.state.files.length === 0 && this.state.images.length === 0) &&
                                <p className="calendarDropZonePlaceholder" >
                                  Arrastre las imagenes que desea publicar
                                </p>
                              }
                            </div>
                            <div className="calendarFilesType">
                              {this.placeholderType()}
                            </div>
                          </Dropzone>
                        </div>
                      </div>
                      <div className="calendarInputCopy">
                        <textarea
                          ref={(copy)=>(this.copy = copy)}
                          placeholder="COPY"
                          className="calendarCopyTextArea"
                          value={this.state.copy}
                        />
                        <div id="emojiArea" />
                        <p className="calendarCopywords">
                          {this.state.copy ? this.state.copy.length : 0}
                        </p>
                      </div>
                      <div className="calendarComments">
                        <div className="calendarCommentsComment">
                          <div className="calendarInput">
                            <textarea
                              disabled={this.state.update && !this.state.edit}
                              placeholder="COMMENT"
                              defaultValue={this.state.comments}
                              onKeyUp={(event)=>{
                                event.persist()
                                this.onKeyUpMessage(event)
                              }}
                              className="calendarCopyTextArea"
                            />
                          </div>
                        </div>
                        <div className="calendarCommentsStatus">
                          <div className="calendarStatus">
                            <DropDown
                              disabled={this.state.update && !this.state.edit}
                              bsStyle='default'
                              title={this.state.client_state}
                            >
                              <DropdownSem.Item
                                onClick={()=>{
                                  this.onChangeState('NOT CONTENT')
                                }}  
                                active={this.state.client_state === 'NOT CONTENT'}>
                                NOT CONTENT
                              </DropdownSem.Item>
                              <DropdownSem.Item
                                onClick={()=>{
                                  this.onChangeState('MISSING APPROVAL')
                                }} 
                                active={this.state.client_state === 'MISSING APPROVAL'}>
                                MISSING APPROVAL
                              </DropdownSem.Item>
                              <DropdownSem.Item 
                                onClick={()=>{
                                  this.onChangeState('WORKING IN CHANGES')
                                }} 
                                active={this.state.client_state === 'WORKING IN CHANGES'}>
                                WORKING IN CHANGES
                              </DropdownSem.Item>
                              {permissions['ApprovedByClient'] && (
                                <DropdownSem.Item 
                                  onClick={()=>{
                                    this.onChangeState('APPROVED BY CLIENT')
                                  }} 
                                  active={this.state.client_state === 'APPROVED BY CLIENT'}>
                                  APPROVED BY CLIENT
                                </DropdownSem.Item>
                              )}
                            </DropDown>
                          </div>
                        </div>
                      </div>
                      <div className="calendarPostsAddFooter">
                        <div className="grid">
                          <div className="col-7">
                            <div 
                              className="calendarAccounts" 
                              ref={(accounts)=>(this.accounts = accounts)}>
                              {this.state.networks.map((network)=>{
                                return (
                                  <div>
                                    <input
                                      disabled={this.state.update && !this.state.edit} 
                                      type={this.state.update ? 'radio' : 'checkbox'}
                                      name="accounts" 
                                      id={network.provider}
                                      onChange={()=>(this.onChangeNetworks(network.provider, this.state.update))}
                                      checked={this.state.activeNetworks.includes(network.provider)} 
                                      value={network.provider}
                                    />
                                    <label
                                      disabled={this.state.update && !this.state.edit}
                                      htmlFor={network.provider}
                                      className='accountSocialNetworkCalendar' 
                                      provider={network.provider}
                                      style={{backgroundImage:`url(${network.picture})`}}>
                                      <i className="fas fa-check" />
                                    </label>
                                  </div>
                              )})}
                            </div>
                          </div>
                          <div className="col-5">
                            <div className="newCalendarButtons">
                              {((this.state.update && this.state.edit) || !this.state.update) && (
                                <button
                                  disabled={this.state.update && this.state.client_state != 'APPROVED BY CLIENT'}
                                  onClick={()=>{
                                    this.validate()
                                    .then(this.onCreate)
                                    .catch((error)=>{
                                      this.alert.show({body: error})
                                    })
                                  }}
                                  className="newCalendarCreate">
                                  {this.state.update ? 'Ready To Post' : 'Create'}
                                </button>
                              )}

                              {(this.state.update && this.state.client_state == 'APPROVED BY CLIENT' && !this.state.edit) && (
                                <button
                                  onClick={()=>{
                                    this.setState({
                                      edit: true
                                    }, ()=>{
                                      window.jQuery(this.copy).data("emojioneArea").enable()
                                    })
                                  }}
                                  className="newCalendarEdit">
                                  Edit
                                </button>
                              )}

                              <button
                                onClick={this.onDelete} 
                                className="newCalendarDelete">
                                {(this.state.update && this.state.edit) ? 'Delete' : 'Cancel'}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </div>
                  <div className="col-5">
                    <Card className="bp3-dark">
                      <div className="calendarPostsMessages">
                        <ul>
                          {this.getPosts().slice(0, 5).map((post)=>{
                            return (
                              <li><Truncate text={post.message} clamp={10} /></li>
                            )
                          })}
                        </ul>
                      </div>
                    </Card>
                  </div>
                  <div className="col-12">
                    <Card className="bp3-dark">
                      {this.renderBestPostsImages()}
                    </Card>
                  </div>
                </div>
                {this.props.showLabels && (
                  <div className="bp3-card bp3-elevation-0 bp3-dark newEventLabels">
                    <p className="newEventLabelsTitle">Labels</p>
                    <ul>
                      {this.state.labels.map((label, index)=>{
                        return (
                          <li>
                            <p><spam>{index+1}. </spam>{label.name}</p>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                )}
                {this.state.loading && (
                  <div className="newEventLoading">
                    <Loading />
                  </div>
                )}
              </div>
            </div>
          )}
      </Modal>    
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    categories: state.categories.categories
  }
}

export default connect(mapStateToProps, null, null, { withRef: true })(NewEvent)



// WEBPACK FOOTER //
// ./src/components/Calendar/components/NewEvent/index.js